import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axiosConfig });

export default function useGetStockCodes() {
  return useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/lwadmin/stock_codes',
    method: 'GET',
  }, { manual: true });
}
